/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

const BlingIcon = ({ width, height, fill, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        {...props}>
        <title>bling</title>
        <g fill="none" fillRule="nonzero">
            <path d="M24 0v24H0V0h24ZM12.593 23.258l-.011.002-.071.035-.02.004-.014-.004-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113-.013.002-.185.093-.01.01-.003.011.018.43.005.012.008.007.201.093c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.004-.011.017-.43-.003-.012-.01-.01-.184-.092Z" />
            <path
                fill={fill}
                d="M10.077 2.614c.338-.76 1.379-.797 1.787-.114l.059.114 1.042 2.345a11 11 0 0 0 4.337 4.931l.322.189 1.85 1.04a1.01 1.01 0 0 1 .109 1.692l-.108.07-1.851 1.04a11 11 0 0 0-4.502 4.782l-.157.338-1.042 2.345c-.338.76-1.379.797-1.787.114l-.059-.114-1.042-2.345a11 11 0 0 0-4.337-4.931l-.322-.189-1.85-1.04a1.01 1.01 0 0 1-.109-1.692l.108-.07 1.851-1.04a11 11 0 0 0 4.502-4.782l.157-.338 1.042-2.345ZM11 5.462C9.756 8.262 7.714 10.496 5.04 12c2.674 1.504 4.716 3.738 5.96 6.538 1.248-2.807 3.29-5.036 5.96-6.538-2.674-1.504-4.716-3.738-5.96-6.538Zm8.22-3.34a5.732 5.732 0 0 0 2.415 2.673c.16.09.16.32 0 .41A5.732 5.732 0 0 0 19.22 7.88a.241.241 0 0 1-.44 0 5.732 5.732 0 0 0-2.415-2.674.236.236 0 0 1 0-.41A5.732 5.732 0 0 0 18.78 2.12a.241.241 0 0 1 .44 0Z" />
        </g>
    </svg>
);

BlingIcon.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    fill: PropTypes.string,
};

BlingIcon.defaultProps = {
    width: 20,
    height: 20,
    fill: '#e1bf40',
};

export default BlingIcon;
